<template>
  <div class="d-inline">
    <span
      class="mx-1 point a__effect"
      @click="$bvModal.show('changelog__modal')"
      @keydown.enter.prevent="$bvModal.show('changelog__modal')"
      @keydown.space.prevent="$bvModal.show('changelog__modal')"
      role="button"
      tabindex="0"
      :aria-label="$t('app.note_rilascio')"
    >
      {{ $t('app.note_rilascio') }}
    </span>
    <b-modal 
      scrollable 
      id="changelog__modal" 
      hide-footer 
      size="xl" 
      :title="$t('app.note_rilascio')"
      :aria-label="$t('app.note_rilascio_modal_label')"
    >
      <!-- Una versione per blocco (pattern .release-note di _pages.scss §37):
           in testa la pillola della versione e la data, sotto un'etichetta per
           tipo di modifica con il testo accanto. Prima le etichette erano
           varianti di Puntofarma (ter-1, ter-2, sec-2) che in ConCura non
           esistono: «Miglioramenti» usciva bianco su azzurro chiaro e più
           largo della sua pillola. -->
      <article v-for="(log, ind) in visibleLogs" :key="ind" class="release-note">
        <header class="release-note__head">
          <b-badge pill :variant="log.versionVariant">{{ versionInitials[$root.scope] }}{{ log.version }}</b-badge>
          <h3 class="release-note__date">{{ log.releaseDate }}</h3>
          <b-badge v-if="ind === 0" pill variant="light">Ultima versione</b-badge>
        </header>
        <p v-if="log.userManual" class="release-note__manual" v-html="log.userManual.text"></p>
        <div v-if="log.new.show" class="release-note__change">
          <b-badge pill variant="success">Novità</b-badge>
          <p class="release-note__text" v-html="log.new.text"></p>
        </div>
        <div v-if="log.improved.show" class="release-note__change">
          <b-badge pill variant="info">Miglioramenti</b-badge>
          <p class="release-note__text" v-html="log.improved.text"></p>
        </div>
        <div v-if="log.fixed.show" class="release-note__change">
          <b-badge pill variant="warning">Correzioni</b-badge>
          <p class="release-note__text" v-html="log.fixed.text"></p>
        </div>
      </article>
    </b-modal>
  </div>
</template>
<script>
import { tcsurvey } from "../../../_store/tcsurvey.module";

export default {
  name: "ChangeLogComponent",
  data() {
    return {
      logs: [
        {
          version: "01.04.01",
          versionVariant: "primary",
          releaseDate: "11 Settembre 2026",
          new: {
            show: true,
            text:
              "Integrato il <b>sistema ASE per la fatturazione</b> da parte dell'operatore sanitario. " +
              "Le strutture possono adesso configurare il <b>tema grafico</b> di propria preferenza all'interno della loro area privata.",
          },
          improved: {
            show: true,
            text:
              "Aggiornamenti sul <b>profilo sanitario</b> del paziente per note e scheda anamnestica, ottimizzazione del <b>questionario di raccolta sintomi</b> e miglioramenti sul <b>calendario dell'operatore</b>. " +
              "Gestione delle <b>segnalazioni dei pazienti</b> per gli operatori in ambito di progetto sperimentale.",
          },
          fixed: {
            show: true,
            text:
              "Ripristinate le <b>schede di sintesi in homepage</b> per gli utenti che non le visualizzavano più, " +
              "ripristinate le <b>selezioni di progetto e di operatore per prestazione</b> per il personale del centro servizi.",
          },
        },
        {
          version: "01.03.03",
          versionVariant: "secondary",
          releaseDate: "01 Aprile 2026",
          new: {
            show: false,
            text: "",
          },
          improved: {
            show: true,
            text:
              "Migliorata la visualizzazione dei dati nel <b>profilo sanitario</b>, dell'esito di compilazione del <b>questionario</b> e dei <b>consumi di sottoscrizione</b>. " +
              "Migliorata la <b>gestione dei permessi</b> degli operatori.",
          },
          fixed: {
            show: true,
            text:
              "<b>Rinnovi sottoscrizione</b>: fix su rinnovi sottoscrizione. " +
              "<b>Refusi testuali</b>: fix refusi testuali.",
          },
        },
        {
          version: "01.03.02",
          versionVariant: "secondary",
          releaseDate: "16 Febbraio 2026",
          new: {
            show: false,
            text: "",
          },
          improved: {
            show: true,
            text:
              "<b>Log profilo sanitario</b>: ampliati i log sul profilo sanitario e i promemoria di somministrazione farmaci. " +
              "<b>Accessibilità</b>: miglioramenti grafici per l'accessibilità. " +
              "<b>Accesso CIE</b>: esteso accesso tramite CIE. " +
              "<b>Gestione prenotazioni Centro Servizi</b>: migliorato il flusso di gestione delle richieste di prenotazione da parte del Centro Servizi.",
          },
          fixed: {
            show: true,
            text:
              "<b>Cambio password</b>: corretto il blocco della schermata successivo al cambio password. " +
              "<b>Refusi grafici</b>: fix refusi grafici.",
          },
        },
        {
          version: "01.03.01",
          versionVariant: "secondary",
          releaseDate: "29 Ottobre 2025",
          new: {
            show: true,
            text:
              "<b>Sezione Anamnesi</b>: raccolta e consultazione della storia clinica in scheda paziente. " +
              "<b>Referti in app</b>: visualizzazione dei referti direttamente dall'applicazione. " +
              "<b>Supporto Multilingua</b>: Portale disponibile in più lingue. " +
              "<b>Ricette digitali</b>: produzione e conservazione delle ricette mediche. " +
              "<b>Diario Sintomi</b>: registrazione e monitoraggio dei sintomi del paziente. " +
              "<b>Sintomi e somministrazioni</b>: gestione di sintomi e somministrazioni nella scheda paziente. " +
              "<b>Firma documenti in TC</b>: firma digitale documenti durante il teleconsulto. " +
              "<b>Sessioni questionari</b>: gestione e somministrazione sessioni di questionari. " +
              "<b>Integrazione SPID</b>: autenticazione tramite identità digitale. " +
              "<b>Onboarding strutture convenzionate</b>: creazione e inserimento migliorato di strutture sanitarie convenzionate. " +
              "<b>Reportistica marketing</b>: nuovi report in area amministratore.",
          },
          improved: {
            show: true,
            text:
              "<b>Selezione telecamera</b>: possibilità di selezionare la telecamera in sessione TC. " +
              "<b>Paginazione log accessi</b>: migliorata la consultazione dei log " +
              "<b>Codici fiscali esteri</b>: gestione dedicata per soggetti nati all'estero. " +
              "<b>Footer e storico manuali</b>: aggiornamento footer con accesso ai manuali precedenti. " +
              "<b>Specializzazioni operatori</b>: inserita la possibilità di selezionare la specializzazione per operatori. " +
              "<b>Configuratore questionario</b>: miglioramenti alla creazione questionari. " +
              "<b>Scheda sanitaria</b>: aggiornamenti sulla scheda sanitaria del paziente.",
          },
          fixed: {
            show: true,
            text:
              "<b>Fix API Biobeat</b>: risolti problemi di integrazione con dispositivi Biobeat. " +
              "<b>Fix applicazione mobile</b>: correzioni sulla versione mobile.",
          },
          userManual: {
            show: true,
            text: "*Rilasciata nuova versione del manuale utente",
          }
        },
        {
          version: "01.02.02",
          versionVariant: "secondary",
          releaseDate: "21 Aprile 2025",
          new: {
            show: true,
            text:
              "<b>Variazioni per Teleconsulto rapido e pediatrico</b> per l'attivazione dei relativi sottotipi. " +
              "<b>Implementazione API dedicate a nuove sperimentazioni</b>, esponendo metodi per la memorizzazione di note e rilevazioni.",
          },
          improved: {
            show: true,
            text:
              "<b>Blocco caricamento ricette</b>: rimozione della funzionalità di upload delle ricette durante il percorso di prenotazione dei prodotti. " +
              "<b>Gestione numero massimo di login errati</b>: limitazione a 3 tentativi falliti in 5 minuti per migliorare la sicurezza. " +
              "<b>Aggiornamento note prenotazione con notifica</b>: le note di prenotazione (sia cittadino che operatore) risultano modificabili fino al giorno e all'orario previsti per l'appuntamento; ad ogni modifica viene inviata una notifica alla controparte. " +
              "<b>Aggiornamento Cookie Policy</b>: aggiornamento del documento e inserimento del collegamento nel footer dell'applicazione. " +
              "<b>Variazioni visualizzazione area report (admin)</b>: modifica della visualizzazione e aggiornamenti grafici correlati. " +
              "<b>Edit grafico form di registrazione</b>: aggiornamento dello stile del form di registrazione. " +
              "<b>Variazioni grafiche offerta commerciale</b>: aggiornamento delle immagini riepilogative delle sottoscrizioni.",
          },
          fixed: {
            show: true,
            text:
              "<b>Visualizzazione errori di validazione in arruolamento</b>: i messaggi di validazione vengono ora mostrati in una finestra modale. " +
              "<b>Fix annullamento numero verificato di utente eliminato</b>: un numero precedentemente verificato viene nuovamente reso disponibile se l'utente associato è stato eliminato. " +
              "<b>Fix logout utente da recupero password</b>: chiusura della sessione attiva per permettere il completamento della procedura di recupero. " +
              "<b>Fix vulnerabilità da test di sicurezza</b>: applicati i miglioramenti suggeriti dai test. " +
              "<b>Fix apertura app da link in social Meta su iOS</b>: risolto il problema che impediva il corretto caricamento dell'app su dispositivi iOS.",
          },
          userManual: {
            show: true,
            text: "*Rilasciata nuova versione del manuale utente",
          }
        },
        {
          version: "01.02.01",
          versionVariant: "primary",
          releaseDate: "01 Dicembre 2024",
          new: {
            show: true,
            text: "<b>Monitoraggio</b>: servizio che permette il monitoraggio da remoto di parametri e score dei pazienti. <b>Blog</b>: le strutture sanitarie abilitate a specifici progetti possono generare e diffondere contenuti per gli utenti coinvolti. <b>Teleconsulto Rapido</b>: il nuovo servizio che mette a disposizione dei cittadini personale qualificato con tempi di risposta rapidi. <b>Centro Servizi</b>: operatori a disposizione dei cittadini per la gestione dei protocolli di monitoraggio e delle prenotazioni degli assistiti. <b>Acquisti in app</b>: integrato il sistema di pagamento Nexi per l'acquisto di prestazioni e sottoscrizioni ove previsto. <b>Libreria personalizzata</b> per l'operatore, per tenere a portata di mano tutti i collegamenti utili.",
          },
          improved: {
            show: true,
            text: "Migliorati per il cittadino l'agenda con la possibilità di inserire <b>eventi personalizzati</b> ed il Circolo di Cura con la funzionalità <b>\"Invita il mio medico\"</b>; inserito anche un chatbot per la ricerca del <b>centro vaccinale più vicino</b>. Miglioramenti sulle impostazioni di terapie e sulle configurazioni delle prestazioni da operatore. Aggiornamento dell'interfaccia grafica per una migliore accessibilità alla piattaforma. Miglioramenti finalizzati alla gestione delle attività di supporto da amministratore di piattaforma. Funzionalità per le attività di marketing.",
          },
          fixed: {
            show: tcsurvey,
            text: "Ripristinate le <b>notifiche push </b>.",
          },
          userManual: {
            show: true,
            text: "*Rilasciata nuova versione del manuale utente",
          }
        },
        {
          version: "01.01.09",
          versionVariant: "secondary",
          releaseDate: "29 Febbraio 2024",
          new: {
            show: false,
            text: "",
          },
          improved: {
            show: true,
            text: "Miglioramenti sulla validazione dei numeri di telefono.",
          },
          fixed: {
            show: true,
            text: "<b>Fix errore arruolamento senza anagrafica</b>: risolto l'errore che provocava l'arruolamento di un paziente senza anagrafica.",
          },
        },
        {
          version: "01.01.08",
          versionVariant: "secondary",
          releaseDate: "29 Gennaio 2024",
          new: {
            show: false,
            text: "",
          },
          improved: {
            show: true,
            text: "<b>Miglioramenti sulle prenotazioni</b>: aggiunti selettori per agevolare la scelta della data di prenotazione e la gestione dell'operatore dedicato; l'operatore può inoltre inserire una prenotazione pregressa. Miglioramenti sui report dei <b>questionari nella scheda paziente</b> e gestione dei codici fiscali di <b>soggetti nati all'estero</b>. Introdotti selettori per anno e mese nell'agenda per velocizzarne lo scorrimento.",
          },
          fixed: {
            show: true,
            text: "<b>Sicurezza</b>: gestione del timeout di sessione per l'operatore sanitario per scollegare l'utente inattivo.",
          },
        },
        {
          version: "01.01.07",
          versionVariant: "secondary",
          releaseDate: "05 Dicembre 2023",
          new: {
            show: true,
            text: "<b>Lista pazienti</b>: in area pazienti trovi adesso la lista dei tuoi assistiti, per un accesso alla scheda più rapido. <b>Gestione questionari</b>: puoi adesso modificare ed eliminare i questionari somministrati. <b>Codici esenzione</b>: introdotta la gestione dei codici esenzione nella sezione Patologie della scheda paziente. <b>Sezione dispositivi</b> nella scheda paziente: visualizzazione dei dispositivi indossabili acquistati dal paziente.",
          },
          improved: {
            show: true,
            text: "<b>Migliorata la selezione dello slot di prenotazione</b>: inseriti selettore anno e mese per velocizzare la selezione dello slot di prenotazione. <b>Più opzioni per le notifiche di promemoria</b>: inserite più opzioni per l'invio notifiche di promemoria, per i monitoraggi a lungo termine. <b>Aggiornamento anagrafica paziente</b>: introdotto i campi facoltativi dedicati al medico di base e all'azienda sanitaria locale del paziente.",
          },
          fixed: {
            show: true,
            text: "<b>Validazione numero di telefono</b>: verifica sulla formattazione del numero di telefono in caso di inserimento di prefisso. <b>Ricezione notifiche push</b>: puoi ricevere le notifiche push su tutti i dispositivi da cui hai eseguito l'accesso.",
          },
          userManual: {
            show: true,
            text: "*Rilasciata nuova versione del manuale utente",
          }
        },
        {
          version: "01.01.06",
          scope: "puntofarma",
          versionVariant: "secondary",
          releaseDate: "03 Agosto 2023",
          new: {
            show: true,
            text:
              "<b>Nuove misure di sicurezza</b>: ora è obbligatorio inserire e validare il numero di telefono per pazienti e farmacisti. " +
              "<b>Recupero password tramite codice fiscale</b>: se non è possibile accedere alla casella email, sarà possibile recuperare la password tramite codice fiscale e numero di telefono. " +
              "<b>Sezione Social & Web</b>: la farmacia può inserire i collegamenti ai propri canali social e al sito web, visualizzabili da tutti i cittadini.",
          },
          improved: {
            show: true,
            text:
              "<b>Controllo sulle visualizzazioni del profilo sanitario</b>: tramite autorizzazione OTP il paziente ha pieno controllo sulle visualizzazioni del proprio profilo. " +
              "<b>Arruolamento senza email</b>: ora è possibile arruolare in piattaforma un paziente privo di casella email. " +
              "<b>Ottimizzazioni sui Piani Terapeutici</b>: aggiornamento dei campi note con inoltro di notifica per migliorare le comunicazioni con le ASL. " +
              "<b>Autocompilazione campi arruolamento</b>: semplificata la compilazione per un arruolamento più veloce.",
          },
          fixed: {
            show: true,
            text: "",
          },
          userManual: {
            show: true,
            text: "*Rilasciata nuova versione del manuale utente",
          }
        },
        {
          version: "01.01.05",
          scope: "puntofarma",
          versionVariant: "secondary",
          releaseDate: "28 Febbraio 2023",
          new: {
            show: true,
            text:
              "<b>Gestione dei Piani Terapeutici</b>: introdotta la gestione dei Piani Terapeutici per i pazienti cronici in assistenza farmaceutica diretta.",
          },
          improved: { show: false, text: "" },
          fixed: { show: false, text: "" },
          userManual: {
            show: true,
            text: "*Rilasciata nuova versione del manuale utente",
          }
        },
        {
          version: "01.01.04",
          scope: "puntofarma",
          versionVariant: "secondary",
          releaseDate: "20 Gennaio 2023",
          new: { show: false, text: "" },
          improved: {
            show: true,
            text: "Ottimizzazioni e miglioramenti generali dell'interfaccia e delle prestazioni.",
          },
          fixed: { show: false, text: "" },
          userManual: {
            show: true,
            text: "*Rilasciata nuova versione del manuale utente",
          }
        },
        {
          version: "01.01.03",
          scope: "puntofarma",
          versionVariant: "secondary",
          releaseDate: "25 Novembre 2022",
          new: {
            show: true,
            text:
              "<b>Nuovi strumenti per l'operatore sanitario</b>: possibilità di evadere più richieste contemporaneamente dalla vista giornaliera e accesso rapido alle schede assistiti. " +
              "<b>I tuoi assistiti a portata di mano</b>: visualizzazione rapida e accesso alla scheda paziente tramite ricerca per codice fiscale o cognome.",
          },
          improved: {
            show: true,
            text:
              "<b>Miglioramenti sull'agenda dell'operatore</b>: inserito campo di ricerca per cognome e tasto di inserimento nuova prenotazione; revisione dei report di prenotazione per mostrare i contatti dei pazienti.",
          },
          fixed: {
            show: true,
            text:
              "<b>Correzioni</b>: risolto il problema che impediva di prenotare un farmaco e una prestazione nella stessa fascia oraria; vari bug minori corretti.",
          },
          userManual: {
            show: true,
            text: "*Rilasciata nuova versione del manuale utente",
          }
        },
        {
          version: "01.01.02",
          scope: "puntofarma",
          versionVariant: "secondary",
          releaseDate: "27 Ottobre 2022",
          new: {
            show: true,
            text:
              "<b>Impostazione di date di indisponibilità</b>: inserita la funzionalità per aggiungere date (festive e non) su cui non sarà possibile prenotare. " +
              "<b>Aggiornamento note prenotazione</b>: cittadini e operatori possono notificare la controparte con comunicazioni rilevanti per la prenotazione.",
          },
          improved: {
            show: true,
            text:
              "<b>Miglioramenti sull'agenda e sugli ordini di prodotto</b>: migliorata la visibilità delle prestazioni e possibilità di specificare quantità per prodotto, inclusa la gestione di prodotti fuori-lista.",
          },
          fixed: { show: false, text: "" },
          userManual: {
            show: true,
            text: "*Rilasciata nuova versione del manuale utente",
          }
        },
        {
          version: "01.01.01",
          scope: "puntofarma",
          versionVariant: "secondary",
          releaseDate: "25 Agosto 2022",
          new: {
            show: true,
            text:
              "Rilasciata la prima versione con i moduli principali: <b>Modulo core</b> per la gestione sicura delle utenze, <b>Modulo teleconsulto</b> per comunicazione remota tra operatori e pazienti, <b>Modulo prenotazioni</b> per la prenotazione di ordini e prestazioni, e <b>Modulo alert</b> per facilitare il monitoraggio e l'aderenza alla terapia.",
          },
          improved: { show: false, text: "" },
          fixed: { show: false, text: "" },
          userManual: {
            show: true,
            text: "*Rilasciata nuova versione del manuale utente",
          }
        },
      ],
      versionInitials: {
        concura: "CC",
        puntofarma: "PF",
      },
    };
  },
  computed: {
    visibleLogs() {
      const currentScope = (this.$root && this.$root.scope) || '';
      return this.logs.filter(log => {
        if (log.scope) {
          return log.scope === currentScope;
        }
        return true;
      });
    }
  },
};
</script>
